import React from "react";

import firebase from "firebaseFactory";
import { Page } from "modules/layout/Page";
import { useFirebaseListFunction } from "hooks";
import { DeviceReference } from "modules/devices";
import { useAuthDataContext, Permissions } from "modules/auth";

import { AddSiteToDashboard } from "./components/AddSiteToDashboard";
import { SiteCard } from "./components/SiteCard";

export const SummaryDashboard = ({
  getAllPermittedDevices = firebase.function("getAllPermittedDevices"),
  getNow = Date.now,
  getAllSiteIds = firebase.function("getAllSiteIds"),
  addSiteToUser = firebase.function("addSiteToUser"),
}) => {
  const authState = useAuthDataContext();
  const { data: devices, isLoading } = useFirebaseListFunction<DeviceReference>(
    getAllPermittedDevices
  );
  const siteIds = Array.from(new Set(devices.map((x) => x.siteId)));
  return (
    <Page isLoading={isLoading}>
      <div className="flex flex-wrap -mx-2">
        {siteIds.map((siteId, index) => (
          <SiteCard
            key={index}
            devices={devices.filter((device) => device.siteId === siteId)}
            getNow={getNow}
            siteId={siteId}
          />
        ))}
        {siteIds.length === 0 && (
          <p>
            There are no sites configured for this account.
            {!authState.enforcer.can(
              Permissions.Users_AddSiteToPermittedList
            ) && <>Please contact Relectrify support.</>}
          </p>
        )}
      </div>
      <AddSiteToDashboard
        getAllSiteIds={getAllSiteIds}
        addSiteToUser={addSiteToUser}
      />
    </Page>
  );
};
